<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-6">
        <div class="title font-300 font-24 mb-15">
          {{ this.$route.name }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="row">
          <div class="col-sm-4 col-form-label text-right">
            Branch
          </div>
          <div class="col-sm-8">
            <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
              <option :value="null">Please select</option>
              <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="col-sm-3 text-right">
        <div class="width-auto-picker d-flex justify-content-end">
          <flat-pickr @on-change="changeCurrentDate" :config="exportConfig" class="font-13 text-center"
            v-model="searchDate" name="export_date_start"></flat-pickr>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="box-mini mb-20">
          <div class="p-15">
            <div class="font-500">EDC BCA {{ getWhoSubmit('BCA') }}</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Price</strong></td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(type, index) in itemsBCA">
                  <tr :key="index">
                    <td class="text-left">{{ type.payment_type }}</td>
                    <td>Rp. {{ parseCurrency(type.total_amount) }}</td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right font-500">Total</td>
                  <td class="font-500">{{ totalSettlement(itemsBCA) }}</td>
                </tr>
                <tr>
                  <td class="text-right font-500">Total (Uploaded Receipt)</td>
                  <td class="font-500">
                    <template v-if="totalBCA[0]">
                      Rp. {{ parseCurrency(totalBCA[0].total_amount) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-white" v-if="checkDataBCA()">
                    <div v-if="totalBCA[0]">
                      <button @click="showModal('img-receipt' + totalBCA[0].id)" class="btn-table red"><i
                          class="fas fa-file-alt mr-5"></i>Receipt</button>
                      <b-modal modal-class="modal-custom-image" hide-footer :ref="'img-receipt' + totalBCA[0].id"
                        centered title="Receipt Image">
                        <img class="w-100 img-fix" :src="totalBCA[0].image_receipt">
                      </b-modal>
                    </div>
                  </td>
                  <td colspan="2" class="bg-white" v-else>
                    <div class="upload-receipt">
                      <div class="text-left mt-10 font-400">Upload Receipt Image</div>
                      <hr class="short-line left mb-20">
                      <form @submit.prevent="uploadReceipt('bca')" data-vv-scope="bca">
                        <div class="mb-10 text-left">
                          <div class="mb-5">Total Price</div>
                          <b-form-input v-model="addDataBCA.total_amount" name="price_bca"
                            v-validate="'required|numeric'" type="text"></b-form-input>
                          <span class="error">{{ errors.first('bca.price_bca') }}</span>
                        </div>
                        <div class="mb-20 text-left">
                          <div class="mb-5">Receipt</div>
                          <b-form-file name="receipt_image_bca" v-validate="'required'" @change="previewImage"
                            accept="image/*" v-model="addDataBCA.receipt" :state="Boolean(file)"
                            placeholder="Choose a file..."></b-form-file>
                          <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                          <div class="image-preview" v-if="imageData.length > 0">
                            <img class="preview" :src="imageData">
                          </div>
                          <span class="error">{{ errors.first('bca.receipt_image_bca') }}</span>
                        </div>
                        <div class="text-right">
                          <button class="btn-primary pt-5 pb-5">Submit</button>
                        </div>
                      </form>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <div class="box-mini mb-20">
          <div class="p-15">
            <div class="font-500">EDC CIMB {{ getWhoSubmit('CIMB') }}</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Price</strong></td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(type, index) in itemsCIMB">
                  <tr :key="index">
                    <td class="text-left">{{ type.payment_type }}</td>
                    <td>Rp. {{ parseCurrency(type.total_amount) }}</td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right font-500">Total</td>
                  <td class="font-500">{{ totalSettlement(itemsCIMB) }}</td>
                </tr>
                <tr>
                  <td class="text-right font-500">Total (Uploaded Receipt)</td>
                  <td class="font-500">
                    <template v-if="totalCIMB[0]">
                      Rp. {{ parseCurrency(totalCIMB[0].total_amount) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-white" v-if="checkDataCIMB()">
                    <div v-if="totalCIMB[0]">
                      <button @click="showModal('img-receipt' + totalCIMB[0].id)" class="btn-table red"><i
                          class="fas fa-file-alt mr-5"></i>Receipt</button>
                      <b-modal modal-class="modal-custom-image" hide-footer :ref="'img-receipt' + totalCIMB[0].id"
                        centered title="Receipt Image">
                        <img class="w-100 img-fix" :src="totalCIMB[0].image_receipt">
                      </b-modal>
                    </div>
                  </td>
                  <td colspan="2" class="bg-white" v-else>
                    <div class="upload-receipt">
                      <div class="text-left mt-10 font-400">Upload Receipt Image</div>
                      <hr class="short-line left mb-20">
                      <form @submit.prevent="uploadReceipt('cimb')" data-vv-scope="cimb">
                        <div class="mb-10 text-left">
                          <div class="mb-5">Total Price</div>
                          <b-form-input v-model="addDataCIMB.total_amount" name="price_cimb"
                            v-validate="'required|numeric'" type="text"></b-form-input>
                          <span class="error">{{ errors.first('cimb.price_cimb') }}</span>
                        </div>
                        <div class="mb-20 text-left">
                          <div class="mb-5">Receipt</div>
                          <b-form-file name="receipt_image_cimb" v-validate="'required'" @change="previewImage2"
                            accept="image/*" v-model="addDataCIMB.receipt" :state="Boolean(file)"
                            placeholder="Choose a file..."></b-form-file>
                          <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                          <div class="image-preview" v-if="imageData2.length > 0">
                            <img class="preview" :src="imageData2">
                          </div>
                          <span class="error">{{ errors.first('cimb.receipt_image_cimb') }}</span>
                        </div>
                        <div class="text-right">
                          <button class="btn-primary pt-5 pb-5">Submit</button>
                        </div>
                      </form>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- BNI -->
        <div class="box-mini mb-20">
          <div class="p-15">
            <div class="font-500">EDC BNI {{ getWhoSubmit('BNI') }}</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Price</strong></td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(type, index) in itemsBNI">
                  <tr :key="index">
                    <td class="text-left">{{ type.payment_type }}</td>
                    <td>Rp. {{ parseCurrency(type.total_amount) }}</td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right font-500">Total</td>
                  <td class="font-500">{{ totalSettlement(itemsBNI) }}</td>
                </tr>
                <tr>
                  <td class="text-right font-500">Total (Uploaded Receipt)</td>
                  <td class="font-500">
                    <template v-if="totalBNI[0]">
                      Rp. {{ parseCurrency(totalBNI[0].total_amount) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-white" v-if="checkDataBNI()">
                    <div v-if="totalBNI[0]">
                      <button @click="showModal('img-receipt' + totalBNI[0].id)" class="btn-table red"><i
                          class="fas fa-file-alt mr-5"></i>Receipt</button>
                      <b-modal modal-class="modal-custom-image" hide-footer :ref="'img-receipt' + totalBNI[0].id"
                        centered title="Receipt Image">
                        <img class="w-100 img-fix" :src="totalBNI[0].image_receipt">
                      </b-modal>
                    </div>
                  </td>
                  <td colspan="2" class="bg-white" v-else>
                    <div class="upload-receipt">
                      <div class="text-left mt-10 font-400">Upload Receipt Image</div>
                      <hr class="short-line left mb-20">
                      <form @submit.prevent="uploadReceipt('bni')" data-vv-scope="bni">
                        <div class="mb-10 text-left">
                          <div class="mb-5">Total Price</div>
                          <b-form-input v-model="addDataBNI.total_amount" name="price_bni"
                            v-validate="'required|numeric'" type="text"></b-form-input>
                          <span class="error">{{ errors.first('cimb.bni') }}</span>
                        </div>
                        <div class="mb-20 text-left">
                          <div class="mb-5">Receipt</div>
                          <b-form-file name="receipt_image_bni" v-validate="'required'" @change="previewImage4"
                            accept="image/*" v-model="addDataBNI.receipt" :state="Boolean(file)"
                            placeholder="Choose a file..."></b-form-file>
                          <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                          <div class="image-preview" v-if="imageData4.length > 0">
                            <img class="preview" :src="imageData4">
                          </div>
                          <span class="error">{{ errors.first('cimb.receipt_image_bni') }}</span>
                        </div>
                        <div class="text-right">
                          <button class="btn-primary pt-5 pb-5">Submit</button>
                        </div>
                      </form>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- END BNI -->

        <!-- BRI -->
        <div class="box-mini mb-20">
          <div class="p-15">
            <div class="font-500">EDC BRI {{ getWhoSubmit('BRI') }}</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Price</strong></td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(type, index) in itemsBRI">
                  <tr :key="index">
                    <td class="text-left">{{ type.payment_type }}</td>
                    <td>Rp. {{ parseCurrency(type.total_amount) }}</td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right font-500">Total</td>
                  <td class="font-500">{{ totalSettlement(itemsBRI) }}</td>
                </tr>
                <tr>
                  <td class="text-right font-500">Total (Uploaded Receipt)</td>
                  <td class="font-500">
                    <template v-if="totalBRI[0]">
                      Rp. {{ parseCurrency(totalBRI[0].total_amount) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-white" v-if="checkDataBRI()">
                    <div v-if="totalBRI[0]">
                      <button @click="showModal('img-receipt' + totalBRI[0].id)" class="btn-table red"><i
                          class="fas fa-file-alt mr-5"></i>Receipt</button>
                      <b-modal modal-class="modal-custom-image" hide-footer :ref="'img-receipt' + totalBRI[0].id"
                        centered title="Receipt Image">
                        <img class="w-100 img-fix" :src="totalBRI[0].image_receipt">
                      </b-modal>
                    </div>
                  </td>
                  <td colspan="2" class="bg-white" v-else>
                    <div class="upload-receipt">
                      <div class="text-left mt-10 font-400">Upload Receipt Image</div>
                      <hr class="short-line left mb-20">
                      <form @submit.prevent="uploadReceipt('bri')" data-vv-scope="bni">
                        <div class="mb-10 text-left">
                          <div class="mb-5">Total Price</div>
                          <b-form-input v-model="addDataBRI.total_amount" name="price_bni"
                            v-validate="'required|numeric'" type="text"></b-form-input>
                          <span class="error">{{ errors.first('cimb.bri') }}</span>
                        </div>
                        <div class="mb-20 text-left">
                          <div class="mb-5">Receipt</div>
                          <b-form-file name="receipt_image_bni" v-validate="'required'" @change="previewImage4"
                            accept="image/*" v-model="addDataBRI.receipt" :state="Boolean(file)"
                            placeholder="Choose a file..."></b-form-file>
                          <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                          <div class="image-preview" v-if="imageData4.length > 0">
                            <img class="preview" :src="imageData4">
                          </div>
                          <span class="error">{{ errors.first('cimb.receipt_image_bni') }}</span>
                        </div>
                        <div class="text-right">
                          <button class="btn-primary pt-5 pb-5">Submit</button>
                        </div>
                      </form>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- END BRI -->

        <!-- CASH -->
        <div class="box-mini mb-20">
          <div class="p-15">
            <div class="font-500">CASH {{ getWhoSubmit('CASH') }}</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Price</strong></td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(type, index) in itemsCash">
                  <tr :key="index">
                    <td class="text-left">{{ type.payment_type }}</td>
                    <td>Rp. {{ parseCurrency(type.total_amount) }}</td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right font-500">Total</td>
                  <td class="font-500">{{ totalSettlement(itemsCash) }}</td>
                </tr>
                <tr>
                  <td class="text-right font-500">Total (Uploaded Receipt)</td>
                  <td class="font-500">
                    <template v-if="totalCASH[0]">
                      Rp. {{ parseCurrency(totalCASH[0].total_amount) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-white" v-if="checkDataCASH()">
                    <div v-if="totalCASH[0]">
                      <button @click="showModal('img-receipt' + totalCASH[0].id)" class="btn-table red"><i
                          class="fas fa-file-alt mr-5"></i>Receipt</button>
                      <b-modal modal-class="modal-custom-image" hide-footer :ref="'img-receipt' + totalCASH[0].id"
                        centered title="Receipt Image">
                        <img class="w-100 img-fix" :src="totalCASH[0].image_receipt">
                      </b-modal>
                    </div>
                  </td>
                  <td colspan="2" class="bg-white" v-else>
                    <div class="upload-receipt">
                      <div class="text-left mt-10 font-400">Upload Receipt Image</div>
                      <hr class="short-line left mb-20">
                      <form @submit.prevent="uploadReceipt('cash')" data-vv-scope="cash">
                        <div class="mb-10 text-left">
                          <div class="mb-5">Total Price</div>
                          <b-form-input v-model="addDataCASH.total_amount" name="price_cash"
                            v-validate="'required|numeric'" type="text"></b-form-input>
                          <span class="error">{{ errors.first('cash.price_cash') }}</span>
                        </div>
                        <div class="mb-20 text-left">
                          <div class="mb-5">Receipt</div>
                          <b-form-file name="receipt_image_cash" v-validate="'required'" @change="previewImage3"
                            accept="image/*" v-model="addDataCASH.receipt" :state="Boolean(file)"
                            placeholder="Choose a file..."></b-form-file>
                          <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                          <div class="image-preview" v-if="imageData3.length > 0">
                            <img class="preview" :src="imageData3">
                          </div>
                          <span class="error">{{ errors.first('cash.receipt_image_cash') }}</span>
                        </div>
                        <div class="text-right">
                          <button class="btn-primary pt-5 pb-5">Submit</button>
                        </div>
                      </form>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="box-mini">
          <div class="p-15">
            <div class="font-500">Total Settlement</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Price</strong></td>
                </tr>
              </thead>
              <tbody>
                <!-- <template v-for="(type, index) in items">
                  <tr :key="index">
                    <td>EDC {{type.payment_card}}</td>
                    <td>Rp. {{parseCurrency(type.total_amount)}}</td>
                  </tr>
                </template> -->
                <tr>
                  <td class="text-left">EDC BCA</td>
                  <td>{{ totalSettlement(itemsBCA) }}</td>
                </tr>
                <tr>
                  <td class="text-left">EDC CIMB</td>
                  <td>{{ totalSettlement(itemsCIMB) }}</td>
                </tr>
                <tr>
                  <td class="text-left">EDC BNI</td>
                  <td>{{ totalSettlement(itemsBNI) }}</td>
                </tr>
                <tr>
                  <td class="text-left">EDC BRI</td>
                  <td>{{ totalSettlement(itemsBRI) }}</td>
                </tr>
                <tr>
                  <td class="text-left">CASH</td>
                  <td>{{ totalSettlement(itemsCash) }}</td>
                </tr>
                <tr>
                  <td class="text-right font-500"> <strong>Total</strong> </td>
                  <td class="font-500"> <strong> {{ totalSettlement(items) }} </strong> </td>
                </tr>
                <tr>
                  <td class="text-right font-500"> <strong>Total (Uploaded Receipt)</strong> </td>
                  <td class="font-500">
                    <strong v-if="totalAll">{{ totalSettlement(totalAll) }}</strong>
                    <strong v-else>0</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      branch_id: null,
      dataBranch: [],
      items: [],
      itemsBCA: [],
      itemsCIMB: [],
      itemsBNI: [],
      itemsBRI: [],
      itemsCash: [],
      totalAll: [],
      totalBCA: [],
      totalCIMB: [],
      totalBNI: [],
      totalBRI: [],
      totalCASH: [],
      searchDate: moment(new Date()).format('YYYY-MM-DD'),
      searchDateTime: moment(new Date()).format('LLLL'),
      imageData: '',
      imageData2: '',
      imageData3: '',
      imageData4: '',
      imageData5: '',
      bill: '',
      addDataBCA: {
        total_amount: '',
        receipt: '',
        payment_type: 'BCA'
      },
      addDataCIMB: {
        total_amount: '',
        receipt: '',
        payment_type: 'CIMB'
      },
      addDataBNI: {
        total_amount: '',
        receipt: '',
        payment_type: 'BNI'
      },
      addDataBRI: {
        total_amount: '',
        receipt: '',
        payment_type: 'BRI'
      },
      addDataCASH: {
        total_amount: '',
        receipt: '',
        payment_type: 'CASH'
      },
      file: null,
      exportConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d F Y",
        defaultDate: moment(new Date()).format('YYYY-MM-DD'),
        maxDate: "today"
        // onChange: this.onChange
      },
    }
  },
  computed: {
    typePayment: function () {
      var items = this.items.map(type => type.payment_type_id)
      var temp = []
      for (var i = 0; i < items.length; i++) {
        temp[items[i]] = items[i]
      }
      var filtered = temp.filter(function (el) { return el != null })
      return filtered
    },
    name() {
      return this.$route.name
    }
  },
  methods: {
    changeBranch(event) {
      this.fetchData()
    },
    getWhoSubmit(type) {
      let name = this[`total${type}`][0]
      return (name) ? `[${name.customer_service_id} - ${name.customer_service_name}]` : ''
    },
    checkDataBCA() {
      if (this.totalBCA.length > 0) {
        return true
      } else {
        return false
      }
    },
    checkDataCIMB() {
      if (this.totalCIMB.length > 0) {
        return true
      } else {
        return false
      }
    },
    checkDataBNI() {
      if (this.totalBNI.length > 0) {
        return true
      } else {
        return false
      }
    },
    checkDataBRI() {
      if (this.totalBRI.length > 0) {
        return true
      } else {
        return false
      }
    },
    checkDataCASH() {
      if (this.totalCASH.length > 0) {
        return true
      } else {
        return false
      }
    },
    changeCurrentDate(selectedDates, dateStr, instance) {
      this.searchDate = dateStr
      this.fetchData()
    },
    uploadReceipt(value) {
      // alert confirm
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Upload!'
      }).then((res) => {
        if (res.value) {
          this.loadingActive = true
          this.$validator.validateAll(value).then((result) => {
            if (result) {
              if (this.branch_id == null) {
                this.$toast.error('Please select branch!', 'Error', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
                this.loadingActive = false
                return;
              } else {
                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
                var data = new FormData()
                if (value === 'bca') {
                  data.append('total_amount', this.addDataBCA.total_amount)
                  data.append('receipt', this.addDataBCA.receipt)
                  data.append('payment_type', this.addDataBCA.payment_type)
                }
                if (value === 'cimb') {
                  data.append('total_amount', this.addDataCIMB.total_amount)
                  data.append('receipt', this.addDataCIMB.receipt)
                  data.append('payment_type', this.addDataCIMB.payment_type)
                }
                if (value === 'bni') {
                  data.append('total_amount', this.addDataBNI.total_amount)
                  data.append('receipt', this.addDataBNI.receipt)
                  data.append('payment_type', this.addDataBNI.payment_type)
                }
                if (value === 'bri') {
                  data.append('total_amount', this.addDataBRI.total_amount)
                  data.append('receipt', this.addDataBRI.receipt)
                  data.append('payment_type', this.addDataBRI.payment_type)
                }
                if (value === 'cash') {
                  data.append('total_amount', this.addDataCASH.total_amount)
                  data.append('receipt', this.addDataCASH.receipt)
                  data.append('payment_type', this.addDataCASH.payment_type)
                }
                data.append('receipt_date', this.searchDate)
                // data.append('total_amount', this.addDataBCA.total_amount)
                // data.append('receipt', this.addDataBCA.receipt)
                // data.append('payment_type', this.addDataBCA.payment_type)
                data.append('customer_service_id', localStorage.getItem('paradigm_id'))
                data.append('branch_id', this.branch_id)

                axios.post('crm/v1/settlement/', data).then(response => {
                  this.loadingActive = false
                  // console.log('test', response)

                  this.$router.push('/settlement/history')
                  this.$toast.success('data saved successfully!', 'Success', {
                    position: 'topCenter',
                    icon: 'icon-envelope',
                    progressBarColor: 'rgb(0, 255, 184)',
                    theme: 'dark',
                    backgroundColor: '#565c70',
                    messageColor: '#fff'
                  })

                  // this.fetchData()
                  // reload
                  // window.location.reload()
                }).catch(error => {
                  this.loadingActive = false
                  console.log('error', error.response)
                  // console.log('error', error.response.data.error)
                  if (error.response.data) {
                    this.$toast.success(error.response.data.error, 'Error', {
                      position: 'topCenter',
                      icon: 'icon-envelope',
                      progressBarColor: 'rgb(0, 255, 184)',
                      theme: 'dark',
                      backgroundColor: '#565c70',
                      messageColor: '#fff'
                    })
                  } else {
                    this.$toast.success('Cant saved data!', 'Error', {
                      position: 'topCenter',
                      icon: 'icon-envelope',
                      progressBarColor: 'rgb(0, 255, 184)',
                      theme: 'dark',
                      backgroundColor: '#565c70',
                      messageColor: '#fff'
                    })
                  }
                })
              }
            } else {
              this.loadingActive = false
              this.$toast.success('please fill in required fields!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        }
      })
    },
    uploadReceiptBCA(value1) {
      this.$validator.validateAll(value1).then((result) => {
        if (result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('receipt_date', this.searchDate)
          data.append('total_amount', this.addDataBCA.total_amount)
          data.append('receipt', this.addDataBCA.receipt)
          data.append('payment_type', this.addDataBCA.payment_type)
          data.append('customer_service_id', localStorage.getItem('paradigm_id'))
          // this.addDataBCA.member_id = this.id_lead_member
          axios.post('crm/v1/settlement/', data).then(response => {
            // console.log('test', response)
            this.fetchData()
            this.$router.push('/settlement/submit')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error.response)
            // console.log('error', error.response.data.error)
            if (error.response.data) {
              this.$toast.success(error.response.data.error, 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            } else {
              this.$toast.success('Cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    uploadReceiptCIMB(value2) {
      this.$validator.validateAll(value2).then((result) => {
        if (result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('receipt_date', this.searchDate)
          data.append('total_amount', this.addDataCIMB.total_amount)
          data.append('receipt', this.addDataCIMB.receipt)
          data.append('payment_type', this.addDataCIMB.payment_type)
          data.append('customer_service_id', localStorage.getItem('paradigm_id'))
          // this.addDataCIMB.member_id = this.id_lead_member
          axios.post('crm/v1/settlement/', data).then(response => {
            // console.log('test', response)
            this.fetchData()
            this.$router.push('/settlement/submit')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error.response)
            // console.log('error', error.response.data.error)
            if (error.response.data) {
              this.$toast.success(error.response.data.error, 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            } else {
              this.$toast.success('Cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    uploadReceiptCASH(value3) {
      this.$validator.validateAll(value3).then((result) => {
        if (result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('receipt_date', this.searchDate)
          data.append('total_amount', this.addDataCASH.total_amount)
          data.append('receipt', this.addDataCASH.receipt)
          data.append('payment_type', this.addDataCASH.payment_type)
          data.append('customer_service_id', localStorage.getItem('paradigm_id'))
          // this.addDataCASH.member_id = this.id_lead_member
          axios.post('crm/v1/settlement/', data).then(response => {
            // console.log('test', response)
            this.fetchData()
            this.$router.push('/settlement/submit')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error.response)
            // console.log('error', error.response.data.error)
            if (error.response.data) {
              this.$toast.success(error.response.data.error, 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            } else {
              this.$toast.success('Cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    eachTotal(value) {
      var data = this.items.filter(type => type.payment_type_id === value)
      var total = 0
      for (var i = 0; i < data.length; i++) {
        total += parseInt(data[i].total_amount)
      }
      return 'Rp. ' + total.toLocaleString('id-ID', { maximumFractionDigits: 0 })
    },
    totalSettlement(value) {
      var data = value
      var total = 0
      for (var i = 0; i < data.length; i++) {
        if (data[i].total_amount) {
          total += parseInt(data[i].total_amount)
        } else {
          total += 0
        }
      }
      return 'Rp. ' + total.toLocaleString('id-ID', { maximumFractionDigits: 0 })
    },
    onChangeDate(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      this.exportDates = dateStr
      if (this.exportDates.includes(" to ") === true) {
        this.fetchData()
      }
    },
    getRowCount(items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      if (value) {
        return value.toLocaleString('id-ID', { maximumFractionDigits: 0 })
      } else {
        var dataNew = 0
        return dataNew.toLocaleString('id-ID', { maximumFractionDigits: 0 })
      }
    },
    openPage(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage2: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData2 = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage3: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData3 = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage4: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData4 = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage5: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData5 = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    fetchData() {
      this.loadingActive = true
      axios.get('crm/v1/settlement_report/submit?date=' + this.searchDate + '&branch_id=' + this.branch_id).then(response => {
        var data = response.data
        this.items = data
        this.itemsBCA = data.filter(item => item.payment_card === 'BCA')
        this.itemsCIMB = data.filter(item => item.payment_card === 'CIMB')
        this.itemsBNI = data.filter(item => item.payment_card === 'BNI')
        this.itemsBRI = data.filter(item => item.payment_card === 'BRI')
        this.itemsCash = data.filter(item => item.payment_card === '')
        //console.log('test', response.data.data)
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
      axios.get('crm/v1/settlement?bydate=' + this.searchDate + '&branch_id=' + this.branch_id).then(response => {
        var data2 = response.data.data.rows
        // this.items = data2
        this.totalAll = data2
        this.totalBCA = data2.filter(item => item.payment_type === 'BCA')
        this.totalBNI = data2.filter(item => item.payment_type === 'BNI')
        this.totalBRI = data2.filter(item => item.payment_type === 'BRI')
        this.totalCIMB = data2.filter(item => item.payment_type === 'CIMB')
        this.totalCASH = data2.filter(item => item.payment_type === 'CASH')
        // console.log('test', this.totalCASH.length > 0)
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    if (this.$route.query.receipt_date) {
      this.searchDate = this.$route.query.receipt_date
      // console.log('haha')
    }
    if (this.$route.query.branch_id) {
      this.branch_id = this.$route.query.branch_id
    }
    this.fetchData()
  }
}
</script>

<style></style>
